import Vue from 'vue';
import * as types from './mutation-types';

export default {
  [types.SET_FILE_DETAIL](state, payload) {
    // If no status set, default status is 'success'
    Vue.set(state.files, payload.id, Object.assign({ status: 'success' }, payload));
  },

  [types.CLEAR_FILE_DETAIL](state, fileId) {
    const file = state.files[fileId];
    if (file) {
      state.lastFileDeleted = file;
    }
    Vue.delete(state.files, fileId);
  },

  /** Set a file's data to the state */
  [types.SET_FILE_DATA](state, payload) {
    Vue.set(state.fileData, `${payload.id}`, payload.data);
  },

  /** Create a boolean variable to indicate that a file's data is being fetched */
  [types.SET_FILE_DATA_LOADING](state, payload) {
    Vue.set(state.isFileDataLoading, `${payload.id}`, payload.isLoading);
  },
};
